import React, { useState, useEffect } from 'react';
import { Menu, X, Play } from 'lucide-react';
import './Header.css';

function Header({ onContactClick }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleContactClick = () => {
    setIsMobileMenuOpen(false);
    if (onContactClick) {
      onContactClick();
    }
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header__container container">
        <a href="/" className="header__logo">
          <img src="/images/logo-procumatcher.png" alt="ProcuMatcher" />
        </a>

        <nav className={`header__nav ${isMobileMenuOpen ? 'header__nav--open' : ''}`}>
          <a href="#features" className="header__link" onClick={() => setIsMobileMenuOpen(false)}>
            Fonctionnalités
          </a>
          <a href="#how-it-works" className="header__link" onClick={() => setIsMobileMenuOpen(false)}>
            Comment ça marche
          </a>
          <a href="#stats" className="header__link" onClick={() => setIsMobileMenuOpen(false)}>
            Références
          </a>
          <a 
            href="https://demo.procumatcher.fr" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="header__cta header__cta--secondary"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <Play size={16} />
            Tester la démo
          </a>
          <button onClick={handleContactClick} className="header__cta">
            Obtenir ProcuMatcher
          </button>
        </nav>

        <button 
          className="header__mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Menu"
        >
          {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </header>
  );
}

export default Header;

